export default {
  buttons: {
    checkin: 'Check in for the Unify Challenge',
    deepDiveCheckin: 'Check in for the Deep Dive',
    leave: 'Leave',
    cancel: 'Cancel',
    reschedule: 'Reschedule',
    account: 'Account',
    accessibility: 'Accessibility',
    siteMap: 'Site map',
    logout: 'Log Out',
    close: 'Close',
    done: 'Done',
    joinEvent: 'Join Event',
    cancelOrReschedule: 'Cancel or Reschedule',
    signup: 'Sign Up',
    continue: 'Continue',
    editAccount: 'Edit Account',
    login: 'Log In',
    goHome: 'Go Home',
    darkModeToggle: 'Toggle Dark Mode',
    backToHome: 'Back to Home',
    joinDisabledReason: 'Opens 1 hour before the event starts.',
    copyLink: 'Copy Link',
    copyLinkToClipboard: 'Copy Link to Clipboard',
    copyLinkForStudents: 'Copy student email message',
    justLandingPageLink: 'Copy student signup link only',
    shareViaEmail: 'Share via Email',
    sendThemAnEmail: 'Send them an Email',
    signUpNow: 'Sign Up Now!',
    notReady: 'Not Ready',
    copyLinkToSendToStudents: 'Copy link to send to students',
    goToQuicksight: 'Go to QuickSight',
    showMeMoreData: 'Show me more data',
    shareThisPage: 'Share this page',
    insightsButton: 'Take me to the Insights',
    learnMoreAboutCivicGym: 'Learn more about the Civic Gym',
  },
  toasts: {
    copySuccess: 'copied to clipboard!',
    copyAndEmailSuccess: 'Content copied and email opened!',
    copyError: 'Failed to copy to clipboard',
  },
  siteTitles: {
    account: 'Your Account',
    home: 'Home',
    challenge: {
      waitingRoom: 'Unify America - Unify Challenge',
    },
    deepDive: {
      waitingRoom: 'Unify America - Deep Dive',
    },
  },
  headers: {
    unifyChallenge: 'Unify Challenge',
    deepDive: 'Deep Dive',
  },
  common: {
    skipToContent: 'Skip to main content',
    yes: 'Yes',
    no: 'No',
    confirm: 'Confirm',
    error: 'Error',
    success: 'Success',
    info: 'Info',
    loading: 'Loading',
    operationSuccessful: 'Operation successful',
    here: 'here',
    userLoggedOut: 'User logged out',
    topic: 'Topic',
    deepDiveTopics: {
      // Using snake_case to match the API response
      gun_ownership: 'Gun Ownership and Gun Violence',
      free_speech: 'Free Speech & Hate Speech',
      voting_and_elections: 'Voting in America',
      social_media: 'Social Media & Mental Health',
    },
    footer: {
      copyright: 'Copyright © {year} Unify America, Inc. All Rights Reserved',
      privacyPolicy: 'Privacy Policy',
      dataSecurity: 'Data Security',
      termsOfService: 'Terms of Service',
    },
    name: 'Name',
    firstName: 'First Name',
    lastName: 'Last Name',
    email: 'Email',
    zipCode: 'Zip Code',
    save: 'Save',
    pleaseWait: 'Please wait...',
    unifyAmerica: 'Unify America',
    civicGym: 'Civic Gym',
    noData: 'No data available for the selected filter(s).',
    selectAnEvent: 'Select an event',
    contact: 'Contact',
    seasons: {
      winter: 'Winter',
      fall: 'Fall',
      spring: 'Spring',
      summer: 'Summer',
    },
    unifyChallenge: 'Unify Challenge',
    deepDive: 'Deep Dive',
    dob: 'Birth Month & Year',
  },
  errors: {
    networkError: 'Network error. Please try again later.',
    unknownError: 'An unknown error occurred. Please try again.',
    unauthorized: 'Unauthorized. Please log in again.',
    sessionExpired: 'Your session may have expired. Please log in and try that again.',
    unknownErrorMessage: 'An unknown error occurred. Please try again.',
    unknownValidationError: 'An unknown validation error occurred. Please try again.',
    userNotFound: 'User not found',
    noEventSelected: 'No event selected',
    signupError: 'Error signing up for event',
    orgNotFound: 'Organization not found. Please check the link you used to access this page. You can still register, but you won’t be associated with an organization.',
    noOrgFound: 'No organization found',
    noOrgForUser: 'You are not associated with an organization. If this is incorrect, please let us know.',
    poolNotFound: 'Event not found',
    noChallengesFound: 'You aren’t signed up for any challenges. Sign up below!',
    userNotInOrg: 'User not associated with an organization. Will be treated as an organic/open participant',
    alreadySignedUp: 'You are already signed up for this event. Please try a different event.',
    pageNotFound: '404 - Page not found',
    pageNotFoundDescription: 'Sorry, we couldn’t find the page you were looking for.',
    permissionDenied: 'Permission denied. You do not have access to that resource.',
    failedToFetchPools: 'Failed to fetch events. Please try again later.',
    failedToFetchDemographics: 'Failed to fetch demographics data. Please try again later.',
    failedToFetchInsights: 'Failed to fetch insights data. Please try again later.',
    failedToFetchAttendanceData: 'Failed to fetch attendance data for this pool. Please try again later.',
    badRequest: 'Bad request. Please check your input and try again.',
    noChallengesFoundForAttendance: 'No challenges found for that event. Please select a different event, or try again later.',
    noChallengesFoundInPool: 'No challenges found in this event. Please select a different event, or try again later.',
    noAttendanceDataFound: 'No attendance data found for the selected event. Please try a different event.',
    duplicateAccount: 'An account with this email already exists. Please log in or use a different email address.',
    dashboardAccessError: 'Unable to access dashboard. Please try again later or contact support.',
    challengeNotFound: 'Challenge not found. Please try again later.',
  },
  images: {
    uaLogo: 'Unify America Logo',
  },
  validation: {
    noSchemaFound: 'No schema found for validation',
    firstNameRequired: 'First Name is required',
    lastNameRequired: 'Last Name is required',
    nameRequired: 'Name is required',
    emailInvalid: 'Please enter a valid email address',
    emailValidated: 'Email validated',
    emailRequired: 'Email is required',
    emailTaken: 'This email is already in use.',
    emailNoChange: 'This is the same email address as before. No changes were made.',
    registerEmailInvalid: 'Looks like you already have an account. Click below to verify and continue.',
    emailNotFound: 'Email not found; please try again.',
    pleaseFillRequiredFields: 'Please fill or correct all required fields before continuing.',
    invalidDateFormat: 'Invalid date format. Please use mm/yyyy.',
    maxLengthExceeded: 'Maximum length exceeded; please shorten your response.',
    zipCodeInvalid: 'Invalid zip code; please match the format 12345 or 12345-6789.',
    votingRecordRequired: 'Please tell us how you vote.',
    politicalSpectrumRequired: 'Please enter your political spectrum.',
    howHeardRequired: 'Oops! Please tell us how you heard about the Unify Challenge.',
    urbanRuralRequired: 'Please let us know what kind of place you live in.',
    dobRequired: 'Please enter your birth month and year.',
    dobInvalidFormat: 'Invalid date format. Please use mm/yyyy.',
    dobTooYoung: 'Sorry, users under {age} aren’t allowed to participate.',
    dobInFuture: 'Your date of birth can’t be in the future. Please check your entry.',
    raceRequired: 'Please select your race or ethnicity.',
    sharedGoalsRequired: 'Please share your opinion on shared goals.',
    sharePointOfViewRequired: 'Please let us know your comfort level in sharing your point of view.',
    futureOfDemocracyRequired: 'Please share your opinion on the future of democracy.',
    impactOfConversationRequired: 'Please share your opinion on the impact of our conversations.',
    professorOrOrganizationRequired: 'Please select an instructor.',
    opinionRequired: 'Please share your opinion on this topic to continue.',
    confidenceDiscussingComplexIssuesRequired: 'Please select your confidence level in discussing complex issues.',
    intendedCollegeMajorRequired: 'Please select your intended major.',
    intendedCollegeMajorDescriptionRequired: 'Please specify your intended major.',
    mustBe18ForRecording: 'You must be at least 18 years old to consent to recording.',
    consentRequired: 'You must agree to these terms to participate in Unify America challenges.',
    requiredAssignmentEventTypesRequired: 'Please let us know whether this event is a required assignment for you.',
  },
  components: {
    upcomingEvents: {
      title: 'Your upcoming events',
      subtitle: 'When your date and time come, click the Join Event button and follow the on-screen instructions. And don’t worry! We’ll send you emails beforehand to remind you.',
      emptyTitle: 'You haven’t signed up for an event yet',
      emptySubtitle: 'Join our engaging Unify Challenges and Deep Dive sessions to connect with other Americans and expand your civic conversation skills.',
    },
    playbookCrossLinks: {
      navLabel: 'More from the educator playbook',
      previous: 'Previous',
      next: 'Next',
    },
  },
  pages: {
    // Section 508 clauses 602.2 and 603.2: documentation of the product's accessibility
    // features, for users and for whoever answers their questions. Written plainly and
    // deliberately including what is NOT yet supported — 602.2 covers accessibility and
    // compatibility features, and a list of strengths alone would be misleading.
    accessibility: {
      hubTileLabel: 'Accessibility',
      title: 'Accessibility at Civic Gym',
      intro: 'We want every student and educator to be able to take part in Civic Gym. This page explains the accessibility features that are built in, how to use them, and what we’re still working on. If something here doesn’t work the way it should, we’d like to hear about it.',
      keyboard: {
        title: 'Using Civic Gym with a keyboard',
        intro: 'You can use all of Civic Gym without a mouse.',
        tab: 'Press <strong>Tab</strong> to move forward through links, buttons and form fields, and <strong>Shift + Tab</strong> to move back.',
        activate: 'Press <strong>Enter</strong> or <strong>Space</strong> to activate whatever you have landed on.',
        escape: 'Press <strong>Escape</strong> to close a menu or dialog.',
        focusRing: 'Wherever you are, the item you are on is outlined so you can see it. On dark backgrounds the outline switches to a lighter color so it stays visible.',
        skipLink: 'The first thing you reach on any page is a <strong>Skip to main content</strong> link, which jumps you past the navigation and into the page.',
      },
      screenReader: {
        title: 'Using Civic Gym with a screen reader',
        para1: 'Civic Gym works with screen readers. Buttons, links and form fields are labeled, headings describe the section they introduce, and when a form has a problem the error is announced and names the field that needs attention.',
        para2: 'On the Insights dashboards, every chart is paired with the same information written out as a table, so you do not have to interpret a picture to get the numbers — your screen reader will read the values directly.',
      },
      reading: {
        title: 'Reading and text size',
        zoom: 'You can zoom in or increase text size up to <strong>200%</strong>, and use the site on a phone-sized screen, with nothing cut off.',
        contrast: 'Text and background colors meet the WCAG AA contrast standard, so text stays legible if you have low vision or are in bright light.',
        color: 'Nothing important is signaled by color alone. Where color carries meaning there is also a label, an icon, a pattern or a change in text.',
      },
      media: {
        title: 'Video and live sessions',
        captions: 'The videos in the session waiting room have <strong>captions</strong>.',
        liveCaptions: 'The live conversation has <strong>real-time captions</strong> with speaker labels, so you can read what your partner is saying as they say it.',
        autoplay: 'Nothing plays sound automatically without giving you the controls to pause it or change the volume.',
      },
      gaps: {
        title: 'What we’re still working on',
        intro: 'We would rather tell you what is not ready than let you find out.',
        audioDescription: '<strong>Audio description for the waiting-room videos.</strong> The videos have captions, so you can read the words, but we do not yet have a narration track describing what is shown on screen. If you use audio description, this is a gap for you today.',
        speech: '<strong>Taking part without speaking.</strong> A Civic Gym session is a spoken conversation with another student. The site itself works without speech, but the conversation is spoken, and the in-session chat is there for sorting out microphone and camera trouble rather than as a way to hold the conversation in text. If speaking is not an option for you, please get in touch before your session so we can talk about it.',
      },
      help: {
        title: 'Getting help',
        email: 'Email us and we will help. This is the best route for anything about accessibility, before or after a session:',
        chat: 'During a session, use the <strong>in-event chat</strong> and someone from our team will pick it up.',
        noPhone: 'We do not offer phone support, so email and chat are the two ways to reach us. If you need an accommodation for a session, tell us in advance and we will do what we can.',
      },
      standards: {
        title: 'Standards',
        body: 'Civic Gym is assessed against <strong>WCAG 2.0 and 2.1 Level AA</strong>. A full conformance report is available on request.',
      },
    },
    landing: {
      welcome: 'Welcome',
      students: 'students',
      itsTime: 'It’s time to sign up for the',
      intro: {
        unifyChallenge: {
          para1: 'The Unify Challenge is a virtual intercollegiate event where thousands of students are paired into one-on-one conversations to discuss hot-button issues like mental health, gun laws, immigration, and free speech on campus.',
          para2: 'You and your Challenge partner will share your points of view, find common ground, and demonstrate that it’s possible to have a respectful and meaningful conversation even when you disagree about some things.',
        },
        deepDive: {
          para1: 'The Deep Dive gives you and your conversation partner the chance to thoroughly explore a single critical issue facing America.',
          para2:
            'The two of you will share your experience and perspective on the topic, review and discuss relevant facts and data, and weigh the pros and cons of various solutions to the problem. You’ll also have the chance to brainstorm new ways our country could address the issue.',
          para3: 'This Fall, you will have 4 Deep Dive topics to choose from: Free Speech & Hate Speech; Gun Ownership & Gun Violence; Social Media & Mental Health; or Voting & Representation.',
        },
      },
      heresHow: {
        title: 'Here’s how it works:',
        step1a: 'Tell us about yourself.',
        step1b: 'After you click the sign up button on this page, you’ll complete a short questionnaire. This helps us find you a good match for your conversation.',
        step1c: 'You’ll also select a time and date for your event.',
        step1cIfDeepDive: 'You’ll select a time and date for your event, and will also choose which topic you want to dive into.',
        step2a: 'Look out for our emails.',
        step2b: 'Right after you sign up, we’ll send a confirmation email with your personal event link. We’ll send you reminders, too, usually about 48 hours and 4 hours before your event.',
        step3a: 'Meet your partner and have a conversation.',
        step3b: 'Click your event link and follow the on-screen instructions. You might be thinking… “A video conversation with a total stranger? What will we talk about?” Don’t worry. We make it super easy.',
        step3c: 'Together, you and your partner will follow a discussion guide covering a range of issues, from healthcare to immigration to free speech on campus. And you don’t have to be “into politics”—no prep needed.',
        step3cIfDeepDive: 'Together, you and your partner will follow a discussion guide that takes you deeper and deeper into your chosen topic. And you don’t have to know anything about the topic going in&mdash;no prep needed.',
        step4a: 'Feel hopeful and tell everyone what you just did.',
        step4aIfDeepDive: 'Experience a deeper understanding of your own point of view.',
        step4b:
          'This experience is exhilarating. You’ll want to tell everyone you know what you just did. It’s like going on a rollercoaster that looks scary, but after you go on it and you zoom through the drops and loops, you’re like “I want to do that again!” The Unify Challenge is like that but without the long lines and screaming 13 year olds.',
        step4bIfDeepDive:
          'A lot of students tell us that while they loved the chance to learn about someone else’s background and point of view, they also left the discussion with a more nuanced understanding of their own perspective. This is an experience where you’re diving deeper not only into an important issue, but into your own ideas, values, and beliefs.',
      },
      questions: {
        title: 'Here are some questions we answer a lot.',
        faq: {
          question1: {
            question: 'Who will I be paired up with?',
            answer:
              'Our matching algorithm will pair you up with a student you likely would never meet otherwise. They may be from another school and have a different background and different life experiences than you. They may also have a totally different political ideology than yours. The two of you might not always agree (that would be boring!), but you’ll likely find you have a lot in common when it comes to what you want for our country.',
          },
          question2: {
            question: 'Do I need to know a lot about politics and current events?',
            questionIfDeepDive: 'Do I need to know a lot about the issue we’re discussing?',
            answer: 'Nope. You just need to be yourself, with your unique knowledge and background and life experience, and be willing to share it.',
            answerIfDeepDive: 'Nope. You just need to be yourself, with your unique knowledge and background and life experience, and be willing to share it.',
          },
          question3: {
            question: 'How long will it take?',
            answer: 'About an hour. Sometimes these conversations wrap up sooner. And sometimes they go longer because both partners are having a great time and don’t want it to end.',
          },
          question4: {
            question: 'What if my partner says something offensive or upsetting?',
            answer:
              'That’s very rare, but if something feels off, you don’t have to handle it alone. You can hit the blue button in the lower-right of your screen to reach our live support team. Or you can just leave the conversation and email us at {supportEmail}.',
          },
          question5: {
            question: 'Are the conversations recorded?',
            answer: 'We only record conversations if both you and your partner consented to being recorded when you signed up. Recording isn’t required to participate.',
          },
          question6: {
            question: 'Will my email address or contact info be shared with my partner?',
            answer: 'No. We protect your privacy. Some people really like getting to know each other and may choose to share contact info, but that’s entirely up to you.',
          },
          question7: {
            question: 'What kind of computer setup do I need?',
            answer: 'You will need a desktop, laptop, or tablet that you can use for a video call. The experience won’t work on a mobile phone. We will walk you through everything — it’s easy.',
          },
        },
      },
      socialProof: {
        title: 'Thousands of students from hundreds of colleges and universities have participated in Unify America’s Civic Gym programs.',
      },
    },
    register: {
      hi: 'Hi,',
      description: 'We’ll use some of these questions to match you with your Unify Challenge partner. Your answers are private. We will not share these with anyone.',
      deepDiveDescription: 'We’ll use some of these questions to match you with your Deep Dive partner. Your answers are private. We will not share these with anyone.',
      alreadyRegistered: 'Already have an account? Click here to verify your email.',
      alreadyRegisteredAddOrg: 'Once you sign in, you’ll be able to join Unify Challenges with the organization that gave you the link to this page.',
      clickToAddSchool: 'Click here to add your school to your account.',
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email',
      signUp: 'Sign Up',
      forThe: 'for the',
      signUpForTheUnifyChallenge: 'Sign up for the Unify Challenge!',
      success: 'Your account has been successfully created. Please login below.',
      poolDialog: {
        title: 'Quick question...',
        areYouHereFor: 'Are you a student signing up for the',
        noImNot: 'No, I’m not',
        yesIAm: 'Yes, I’m signing up for the',
      },
      selectOrgDialog: {
        dropdownLabel: 'Please select your organization',
        goBack: 'I’m not here for the',
      },
    },
    login: {
      title: 'Unify America Login',
      label: {
        default: 'Please enter your email address so we can send you a secure verification link.',
        magicLinkExpired: 'Uh oh, your link expired. Don’t worry, it happens. Enter your email and we’ll send you a new link.',
        sessionExpired: 'It’s been awhile! Please enter your email address so we can send you a new secure verification link.',
      },
      helpText: 'A unique one-time link will be sent to your email. Follow the link to login.',
      checkYourEmail: 'Check your email!',
      magicLinkSent: 'We’ve sent a verification email. Open it and click the link to complete your sign-up. The link will expire in 30 minutes.',
      magicLinkButton: 'Email me my link',
      magicLinkInvalid: 'Invalid or expired magic link',
      magicLinkSuccess: 'Magic link successfully verified!',
      magicProcessing: 'Processing magic link...',
      haventRegisteredYet: 'Take me back to the form',
    },
    playbook: {
      aboutTheCivicGym: {
        title: 'About the Civic Gym',
        description:
          'Lorem ipsum dolor sit amet consectetur adipiscing elit. Quisque faucibus ex sapien vitae pellentesque sem placerat. In id cursus mi pretium tellus duis convallis. Tempus leo eu aenean sed diam urna tempor. Pulvinar vivamus fringilla lacus nec metus bibendum egestas. Iaculis massa nisl malesuada lacinia integer nunc posuere. Ut hendrerit semper vel class aptent taciti sociosqu. Ad litora torquent per conubia nostra inceptos himenaeos.',
      },
      participant: {
        hubTileLabel: 'Home',
        title: 'Home',
        home: {
          hubTileLabel: 'Home',
          title: 'Home',
          card1: {
            headerTitle: '“A video conversation with a total stranger? What will we talk about?”',
            headerSubtitle: 'Don’t worry, we make it super easy.',
            footerTitle: 'Review resources to help you prepare',
          },
          card2: {
            headerSubtitle: 'The Unify Challenge is like the thrill of a rollercoaster but without the long lines and screaming 13 year olds.',
            footerTitle: 'Feel hopeful and tell everyone what you just did!',
          },
        },
        conversationTips: {
          hubTileLabel: 'Tips for Great Conversations',
          hubTileDescription: 'Here are some tips to help you engage in meaningful conversations with others.',
          title: 'Tips for Great Conversations',
          callout: 'Your students get access to this page once they sign up. To make sure they see it, you can copy the link to share with them.',
          intro: {
            para1:
              'You’re about to have a rare opportunity: to meet another person you likely would never cross paths with otherwise. We’re going to pair you up with someone who may be from a different school and who may be different from you politically, demographically, and ideologically.',
            para2:
              'You’ll have the chance to discuss important and complicated topics facing our country, but more importantly, you’ll get to really understand another person’s perspective. Most students tell us their conversations help them understand their own point of view better, too.',
          },
          beforeEvent: {
            title: 'Before the event...',
            item1a: 'Look out for our emails.',
            item1b: 'Right after you signed up, we sent a confirmation with your personal event link. We’ll send you reminders, too&mdash;usually about 48 hours and 4 hours before your event.',
            item2a: 'Plan for about an hour.',
            item2b: 'Sometimes these conversations wrap up sooner. And sometimes they go longer because both partners are having a great time and don’t want it to end.',
            item3a: 'Use your laptop.',
            item3b: 'You can use a laptop, tablet, or desktop with a camera and microphone. Don’t use your phone&mdash;these conversations don’t work well on those.',
            item4a: 'Sit somewhere quiet and well-lit.',
            item4b: 'Studies have shown that conversations work best when partners can hear and see one another.',
            item5a: 'Join the event on time.',
            item5b: 'At your scheduled time, click the link in the email we sent you. Then follow the on-screen steps. Try to be on time&mdash;your partner will be waiting!',
          },
          duringEvent: {
            title: 'During the event...',
            tip1a: 'Remember it’s a conversation, not a debate.',
            tip1b: 'No one’s trying to win or shut the other person down. Just be curious, respectful, and honest. You know…be your unique and wonderful self.',
            tip2a: 'Expect some respectful disagreement.',
            tip2b: 'You and your partner might not always agree on everything. If you did, it’d be pretty boring. But you should both expect to be treated with kindness and respect.',
            tip3a: 'Stay present (mentally).',
            tip3b:
              'When your partner is talking, don’t just nod your head waiting for your turn to talk. Listen carefully, be curious, and ask follow-up questions. When people ask you questions, it makes you feel heard and gives you the chance to better understand your own perspectives.',
            tip4a: 'Remember that we’re here if you need us.',
            tip4b: 'If you’re having tech issues or other problems, there’s a blue button in the bottom-right of your screen. Our live support team is a click away.',
          },
          faq: {
            title: 'Here are some questions we answer a lot.',
            question1: {
              question: 'Who will I be paired up with?',
              answer:
                'Our matching algorithm will pair you up with a student you likely would never meet otherwise. They may be from another school and have a different background and different life experiences than you. They may also have a totally different political ideology than yours. The two of you might not always agree (that would be boring!), but you’ll likely find you have a lot in common when it comes to what you want for our country.',
            },
            question2: {
              question: 'Do I need to know a lot about politics and current events?',
              answer: 'Nope. You just need to be yourself, with your unique knowledge and background and life experience, and be willing to share it.',
            },
            question3: {
              question: 'How long will it take?',
              answer: 'About an hour. Sometimes these conversations wrap up sooner. And sometimes they go longer because both partners are having a great time and don’t want it to end.',
            },
            question4: {
              question: 'What if my partner says something offensive or upsetting?',
              answer:
                'That’s very rare, but if something feels off, you don’t have to handle it alone. You can hit the blue button in the lower-right of your screen to reach our live support team. Or you can just leave the conversation and email us at {supportEmail}.',
            },
            question5: {
              question: 'Are the conversations recorded?',
              answer: 'We only record conversations if both you and your partner consented to being recorded when you signed up. Recording isn’t required to participate.',
            },
            question6: {
              question: 'Will my email address or contact info be shared with my partner?',
              answer: 'No. We protect your privacy. Some people really like getting to know each other and may choose to share contact info, but that’s entirely up to you.',
            },
            question7: {
              question: 'What kind of computer setup do I need?',
              answer: 'You will need a desktop, laptop, or tablet that you can use for a video call. The experience won’t work on a mobile phone. We will walk you through everything — it’s easy.',
            },
          },
        },
      },
      educator: {
        title: 'Educator Toolkit',
        tags: {
          toShare: 'to share with students',
          toUseInClassroom: 'to use in the classroom',
          additionalResources: 'additional resources',
        },
        heroLeft: {
          headline: 'Welcome to the Civic Gym Hub!',
          welcomeBackHeadline: 'Welcome back to the Civic Gym Hub!',
          subHeadline: 'The Hub is your one-stop destination to access resources, student signup links, session attendance, and impact data.',
          signupTitle: 'It’s time to sign up your students!',
          insightsTitleDynamic: '{participantCount} students participated in Civic Gym programs this {season}',
          insightsTitleDynamicOver: 'Over {participantCount} students participated in Civic Gym programs this {season}',
          ucSignupDescription:
            'Student signup is now open for the Unify Challenge. We’ve prepared a ready-to-send message that includes your custom student sign-up link. Click below to copy the message, then paste it into an email or syllabus for your students.',
          deepDiveSignupDescription:
            'Student signup is now open for the Deep Dive. We’ve prepared a ready-to-send message that includes your custom student sign-up link. Click below to copy the message, then paste it into an email or syllabus for your students.',
          onlyUCInsightsLiveDescription: 'How’d it go? Which campuses took part? What did students say? Find those answers and more on our Insights page, and check back later for this season’s Deep Dive impact data.',
          bothInsightsLiveDescription: 'How’d it go? What did they say? What schools were they from? Dig into all the Unify Challenge and Deep Dive data on our Insights page!',
          emailSubject: 'Unify America Civic Gym Student Link',
          content: 'https://qa.app2.unifyamerica.org/landing/unify-challenge',
        },
        heroRight: {
          card1: {
            headerTitle: '“A video conversation with a total stranger? What will we talk about?”',
            headerSubtitle: 'Don’t worry, we make it super easy.',
            footerTitle: 'Review resources to lead your students',
          },
          card2: {
            headerSubtitle: '',
            footerTitle: 'Have questions? Need help?',
          },
        },
        playbook: {
          title: 'The Civic Gym Playbook',
          description: 'Here’s where you’ll find classroom activities, info about our programs, and other resources to help you and your students get the most out of the Civic Gym. Can’t find what you need? Just email us at',
        },
        studentEmailMessage: {
          intro: 'Hi everyone,',
          closing: 'Thanks,',
          name: '[name]',
          unifyChallenge: {
            para1a: 'As part of our coursework this',
            para1b: 'we’ll be participating in the Unify Challenge — a virtual, one-on-one conversation with a student from another school. The goal is to practice discussing important issues and collaborating with people outside our normal circle.',
            para2a: 'The Unify Challenge takes place on',
            para2b: '(two sessions offered daily)',
            para2c: 'To take part, just use this link to choose the date and time that works best for you:',
            para4: 'Once you sign up, you’ll receive a confirmation email and reminders from Unify America. If you have any issues, you can reach them at',
          },
          deepDive: {
            para1a: 'As part of our coursework this',
            para1b: 'we’ll be participating in the Deep Dive — a virtual, one-on-one conversation with a student from another school. The goal is to practice important civic skills like active listening and collaborative problem-solving, while discussing a hot-button issue facing our country.',
            para2a: 'The Deep Dives take place on',
            para2b: 'There are multiple sessions offered each day, and multiple topics to choose from: Voting & Representation; Gun Ownership & Gun Violence; Free Speech & Hate Speech; and Social Media & Mental Health.',
            para3: 'To take part, just use this link to select the date, time, and topic that work best for you:',
            para4: 'Once you sign up, you’ll receive a confirmation email and reminders from Unify America. If you have any issues, you can reach them at',
          },
        },
        inTheClassroom: {
          title: 'To Use in the Classroom',
          classDiscussionIdeas: {
            hubTileLabel: 'Class Discussion and Assignment Ideas',
            title: 'Class Discussion and Assignment Ideas',
            quickResponse: {
              title: 'Quick Response Prompts',
              intro: 'After students have participated in the Unify Challenge or Deep Dive, ask them to write 25-50 words in response to each of these three prompts (i.e., 75-150 words total):',
              describeExperience: {
                title: 'Describe Your Experience',
                prompt: 'How did you feel while participating in the event?',
              },
              reflectOnLearning: {
                title: 'Reflect on Your Learning',
                prompt: 'What key insights or lessons did you gain from this experience?',
              },
              evaluateProgram: {
                title: 'Evaluate the Program',
                prompt: 'Do you think this program should be included in future classes? Explain why or why not.',
              },
            },
            longerResponse: {
              title: 'Longer Response Prompts',
              intro: 'Ask students to write a 250-word reflection on their experience with the Unify Challenge or Deep Dive. In their reflection, they should consider the following questions.',
              emotionalJourney: {
                title: 'Emotional Journey',
                prompt: 'What emotions did you feel before, during, and after the event?',
              },
              visionOfFuture: {
                title: 'Vision of America’s Future',
                prompt: 'After discussing the issues, how different were your views on America’s future from your partner’s?',
              },
              impactOnPerspective: {
                title: 'Impact on Perspective',
                prompt: 'How did this experience affect your feelings about the future of our country?',
              },
            },
            thinkWritePairShare: {
              title: 'Think-Write-Pair-Share',
              intro: 'This activity is designed to have your students reflect individually (think/write) and then together (pair/share) about their Unify America Civic Gym experience.',
              thinkPrompt: {
                title: '“Think” prompt:',
                content:
                  'You’ve just completed the Unify Challenge or Deep Dive, an experience where you were paired with another person to discuss political issues. Think about your experience with your partner. What was it like connecting with someone you just met to discuss political issues? You might think about what was challenging, interesting, or surprising.',
              },
              writePrompt: {
                title: '“Write” prompt:',
                content:
                  'Write a short response (50-100 words or take 5 minutes for free writing) that answers the question “What was it like connecting with someone you just met to discuss political issues?” You might think about what was challenging, interesting, or surprising as you compose your response.',
              },
            },
            moreQuestions: {
              title: 'More discussion/reflection assignment questions',
              intro: 'After your students have participated in a Unify America Civic Gym program, have them talk or write about the experience compared to other political conversations in their lives.',
              questions: {
                expectations: 'What expectations did you have going into the Unify Challenge and/or Deep Dive? How did the experience meet or differ from your expectations?',
                connecting: 'What was it like connecting with someone you just met to discuss political issues?',
                thoughtProcess: 'Did this experience change your thought process? Why or why not?',
                civilDiscourse: 'What did this experience teach you about civil discourse?',
                aboutYourself: 'What did this experience teach you about yourself?',
                futureEngagement: 'Will this experience make you more likely to engage in difficult discussions in the future?',
                keyAreas: 'What key areas did you and your partner discuss?',
                strengthsWeaknesses: 'What was one strength of the experience, whether it was the premise, the format, or the conversation guide, etc.? What was one weakness?',
              },
            },
          },
          facilitationGuide: {
            hubTileLabel: 'Facilitation Guide',
            title: 'Facilitating Deeper Dialogue with your Class',
            subHeadline: 'We want to provide educators with question models that foster deeper student engagement with the content and each other while promoting learning through student-centered teaching methods.',
            intro:
              'As you know, great discussions don’t just happen…they’re sparked. We’ve pulled together 14 sets of open-ended questions to help your students connect, reflect, and wrestle with big ideas. Some of these are light and relational, while others go deeper and might challenge students to come out of their comfort zones a bit. Choose what works, give your students a little space to think first, and let the conversations flow.',

            questionGroups: {
              title: 'Guiding Questions for Deeper Discussion',
              group1: {
                title: 'Group #1: Exploratory Questions',
                subtitle: 'Probe basic knowledge',
                question1: 'What do you think about _____?',
                question2: 'How does _____ make you feel?',
                question3: 'What bothers/concerns/confuses you the most about _____?',
                question4: 'What are some ways we might respond to _____?',
              },
              group2: {
                title: 'Group #2: Open Questions',
                subtitle: 'Require no specific response',
                question1: 'What is your understanding of _____?',
                question2: 'What do you want to know about _____?',
                question3: 'What is the first thing you think about in relation to _____?',
                question4: 'What are some questions you have about _____?',
                question5: 'What is one image/scene/event/moment from your experience that relates to _____?',
              },
              group3: {
                title: 'Group #3: Challenging Questions',
                subtitle: 'Examine assumptions, conclusions, and interpretations',
                question1: 'What can we infer/conclude from _____?',
                question2: 'Does _____ remind you of anything?',
                question3: 'What principle do you see operating here _____?',
                question4: 'What does this help you explain?',
                question5: 'How does this relate to other experiences or things you already know?',
              },
              group4: {
                title: 'Group #4: Relational Questions',
                subtitle: 'Ask for comparisons of themes, ideas, or issues',
                question1: 'Do you see a pattern here?',
                question2: 'How do you account for _____?',
                question3: 'What was significant about _____?',
                question4: 'What connections do you see _____?',
                question5: 'What does _____ suggest to you?',
                question6: 'Is there a connection between what you just said and what _____ was saying earlier?',
              },
              group5: {
                title: 'Group #5: Cause and Effect Questions',
                subtitle: 'Ask for causal relationships between ideas, actions, or events',
                question1: 'How do you think _____ relates or causes _____?',
                question2: 'What are some consequences of _____?',
                question3: 'Where does _____ lead?',
                question4: 'What are some pros and cons of _____?',
                question5: 'What is likely to be the effect of _____?',
              },
              group6: {
                title: 'Group #6: Extension Questions',
                subtitle: 'Expand the discussion',
                question1: 'What do the rest of you think?',
                question2: 'How do others feel?',
                question3: 'What did you find noteworthy about this comment?',
                question4: 'How can we move forward?',
                question5: 'Can you give me some specific examples of _____?',
                question6: 'How would you put that another way?',
              },
              group7: {
                title: 'Group #7: Hypothetical Questions',
                subtitle: 'Pose a change in the facts',
                question1: 'What if _____ were from a different _____, how would that change things?',
                question2: 'Would it make a difference if we were in a _____ society/culture?',
                question3: 'How might this dialogue be different if _____?',
                question4: 'What might happen if we were to _____?',
                question5: 'How might your life be different if _____?',
              },
              group8: {
                title: 'Group #8: Diagnostic Questions',
                subtitle: 'Probe motives or causes',
                question1: 'What brings you to say that?',
                question2: 'What do you mean?',
                question3: 'What led you to that conclusion?',
              },
              group9: {
                title: 'Group #9: Priority Questions',
                subtitle: 'Seek to identify the most important issue',
                question1: 'From all that we have talked about, what is the most important concept you see?',
                question2: 'Considering the different ideas in the room, what do you see as the most critical issue?',
                question3: 'What do you find yourself resonating with the most?',
                question4: 'If you had to pick just one topic to continue talking about, what would it be?',
              },
              group10: {
                title: 'Group #10: Process Questions',
                subtitle: 'Elicit satisfaction/buy-in/interest levels',
                question1: 'Is this where we should be going?',
                question2: 'How are people feeling about the direction of this dialogue?',
                question3: 'What perspectives are missing from this dialogue?',
                question4: 'Everyone has been _____ for a while, why?',
                question5: 'How would you summarize this dialogue so far?',
                question6: 'How might splitting into groups/pairs affect our discussion?',
              },
              group11: {
                title: 'Group #11: Analytical Questions',
                subtitle: 'Seek to apply concepts or principles to new or different situations',
                question1: 'What are the main arguments for _____?',
                question2: 'What are the assumptions underlying _____?',
                question3: 'What questions arise for you as you think about _____?',
                question4: 'What implications does _____have?',
                question5: 'Does this idea challenge or support what we have been talking about?',
                question6: 'How does this idea/contribution add to what has already been said?',
              },
              group12: {
                title: 'Group #12: Summary Questions',
                subtitle: 'Elicit syntheses and discussion themes or lessons',
                question1: 'Where are we?',
                question2: 'If you had to pick two themes from this dialogue, what would they be?',
                question3: 'What did you learn?',
                question4: 'What benefits did we gain today?',
                question5: 'What remains unresolved? How can we better process this?',
                question6: 'Based on our dialogue, what will you be thinking about after you leave?',
                question7: 'Let me see if I understand what we have talked about so far… What have I missed?',
                question8: 'Ok, this is what I have heard so far… Does anyone have anything to correct or add?',
              },
              group13: {
                title: 'Group #13: Action Questions',
                subtitle: 'Call for a conclusion or action',
                question1: 'How can we use that information?',
                question2: 'What does this new information say about our own actions/lives?',
                question3: 'How can you adapt this information to make it applicable to you?',
                question4: 'How will you do things differently as a result of this meeting?',
                question5: 'What are our next steps?',
                question6: 'What kind of support do we need as we move forward?',
                question7: 'How does this dialogue fit into our bigger plans?',
              },
              group14: {
                title: 'Group #14: Evaluative Questions',
                subtitle: 'Gauge emotions, anxiety levels, what is going well or not',
                question1: 'Is there anything else you would like to talk about?',
                question2: 'How are you feeling about this now?',
                question3: 'What was a high point for you? A low point?',
                question4: 'Where were you engaged? Disengaged?',
                question5: 'What excited you? Disappointed you?',
              },
            },
          },
        },
        additionalResources: {
          title: 'Additional Resources',
          gymDesign: {
            hubTileLabel: 'Civic Gym Program Design',
            title: 'Civic Gym Program Design',
            headline: 'Civic Gym Program Design',
            subheadline:
              'As the largest and only intercollegiate offering of its kind, our Civic Gym platform is a meaningful addition to every higher education institution looking to enhance experiential learning, equip its students with civic preparedness, and foster respectful dialogue.',
            intro:
              'Our proven methodology is highly regarded by students and faculty alike. It helps reduce partisan animosity and fosters a campus environment that values diverse perspectives and collaborative problem-solving. Grounded in research and built for scale, our programs provide structure for real-time, virtual, one-on-one discussions about pressing national issues between students from different institutions, backgrounds, beliefs, and geographic locations—from Alaska to Florida. Plus, our team does all the heavy lifting with dedicated service, live event support, robust data, and powerful results—making it easy, engaging, and impactful for every campus.',
            sections: {
              programDetails: 'Program Details',
              unifyChallenge: {
                title: 'The Unify Challenge',
                content:
                  'Our flagship program, the Unify Challenge, pairs students from different colleges and backgrounds into a virtual one-on-one conversation during which they discuss 15-20 key topics. For example, a conservative engineering student from a rural community college in Texas might be paired with a liberal sociology student from a state school in Minnesota. Over the course of an hour, they’ll discuss topics ranging from immigration, AI, and mental health to free speech, abortion, and guns. This low-risk, high-impact setting allows students to gain experience in understanding diverse perspectives, engaging in productive disagreement, and practicing civic skills critical to thriving in a pluralistic society.',
                learningGoals: {
                  title: 'Unify Challenge: Learning Goals',
                  intro:
                    'The Unify Challenge offers students the opportunity to engage in conversations with someone holding opposing political views. This experience allows them to share their perspectives, hear alternative viewpoints, and practice respectful disagreement. Through these conversations, students will practice:',
                  goals: {
                    selfUnderstanding: {
                      title: 'Self-Understanding',
                      description: 'Gaining a deeper understanding of their own viewpoints',
                    },
                    articulation: {
                      title: 'Articulation Skills',
                      description: 'Clearly stating their position on various issues',
                    },
                    scenarioAssessment: {
                      title: 'Scenario Assessment',
                      description: 'Assessing and responding to prompted scenarios',
                    },
                    perspectiveRecognition: {
                      title: 'Perspective Recognition',
                      description: 'Recognizing and appreciating different perspectives on hot-button topics',
                    },
                    reasoning: {
                      title: 'Reasoning',
                      description: 'Explaining the reasons behind their opinions',
                    },
                    evidenceSupport: {
                      title: 'Evidence-Based Support',
                      description: 'Supporting their viewpoints with facts or personal experiences',
                    },
                  },
                },
              },
              deepDive: {
                title: 'The Deep Dive',
                content: 'The Deep Dive is our newest Civic Gym program, created in response to student and faculty requests. A one-on-one, virtual, Deep Dive conversation focuses on one topic.',
                content2:
                  'Students work through scenarios, practice active listening, and brainstorm solutions collaboratively. Whether assigned as a standalone experience or as a follow-up to the Unify Challenge, the Deep Dive enables students to connect across institutions, engage in meaningful dialogue about pressing national issues, and develop essential civic skills.',
                learningGoals: {
                  title: 'Deep Dive: Learning Goals',
                  intro:
                    'The Deep Dive helps students explore their perspectives on a single critical issue facing America today while assisting their partner in doing the same through active listening and follow-up questioning. They gain a deeper understanding of the issue, develop a more nuanced viewpoint, practice supporting their opinions with facts, and brainstorm solutions. Through these conversations, students will practice:',
                  goals: {
                    activeListening: {
                      title: 'Active Listening and Perspective Sharing',
                      description: 'Hearing and summarizing each other’s personal experiences and viewpoints',
                    },
                    criticalThinking: {
                      title: 'Critical Thinking and Analysis',
                      description: 'Reviewing, evaluating, and discussing researched facts on the issue',
                    },
                    selfEvaluation: {
                      title: 'Self Evaluation',
                      description: 'Closely examining perspectives in light of new information and a partner’s follow-up questions',
                    },
                    collaborativeProblemSolving: {
                      title: 'Collaborative Problem Solving',
                      description: 'Working together to brainstorm solutions to pressing problems in America',
                    },
                  },
                },
              },
              conversationDesign: {
                title: 'How we design our Civic Gym conversation guides',
                intro:
                  'Our live-event conversation guides are carefully crafted through a comprehensive, iterative process. The goal is to leave students feeling positive about their experience, hopeful for the future, and motivated to continue having meaningful conversations in their daily lives. Here’s our recipe:',
                steps: {
                  research: {
                    title: 'Research and student feedback',
                    description:
                      'We conduct research to understand what topics students care about and are eager to discuss. We also analyze the results of every Civic Gym event to identify which discussion questions led to the most enriching conversations and which, if any, were less effective.',
                  },
                  advisory: {
                    title: 'Advisory consultations',
                    description: 'We regularly consult with our Academic Advisory Council and Student Advisory Board to gather diverse perspectives and expert insights.',
                  },
                  educator: {
                    title: 'Educator feedback',
                    description: 'We actively seek feedback from participating educators to understand their observations and suggestions for improvement.',
                  },
                  iterate: {
                    title: 'And repeat',
                    description: 'We update our discussion guides once or twice a year to ensure the guide remains topical, appropriately challenging, and engaging.',
                  },
                },
              },
              matching: {
                title: 'How Students Are Matched',
                intro:
                  'The Unify Challenge and Deep Dive connect students from all walks of life for meaningful conversations about big issues facing the country. To spark thoughtful dialogue, our delightfully nerdy matching algorithm pairs students based on their responses to key demographic and values-based questions they answer during signup.',
                content:
                  'Our algorithm calculates a “difference score” for each potential pairing, and prioritizes matches where pairs attend different schools, grew up in different geographical locations, and possess the greatest variety in viewpoint and background. This maximizes contrast—and conversation potential—while ensuring a respectful and productive experience. It’s kind of like matchmaking, if Cupid were a data scientist with a passion for democracy.',
              },
            },
          },
          aboutUnifyAmerica: {
            hubTileLabel: 'About Unify America',
            title: 'About Unify America',
            headline: 'About Unify America',
            subHeadline: 'Unify America is a nonpartisan, 501(c)(3) nonprofit on a mission to replace political fighting with collaborative problem-solving.',
            goals: {
              intro: 'With low-risk, high-impact programming for higher education campuses, we bring thousands of students together with engaging, interactive experiences designed to do the following:',
              civicMuscles: 'Help students build and exercise civic muscles',
              reducePolarization: 'Reduce political polarization',
              empowerStudents: 'Empower students to work together to tackle our country’s biggest challenges',
            },
            sections: {
              founders: {
                title: 'Our team',
                content:
                  'Unify America was founded by entrepreneurs whose software companies have connected, delighted, and supported millions of Americans. Our entire team is a group of high-performing, highly experienced experts who are uniquely collaborative, efficient, and know how to use technology and design to innovate and scale.',
              },
              commitment: {
                title: 'Our commitment',
                content:
                  'We’re committed to developing effective programming that educates and empowers students to participate in their democracy with resilience, curiosity, and intellectual humility. We harness the power of different perspectives, not as a platitude, but because it makes the work—and your student outcomes—better.',
              },
            },
          },
          studentSafety: {
            hubTileLabel: 'Norms and Norm-Setting',
            title: 'Norms and Norm-Setting',
            headline: 'Civic Gym Norms and Norm-Setting',
            subheadline:
              'The goal of Unify America’s Civic Gym programming is to facilitate respectful dialogue across political, geographic, racial, and ideological differences. To ensure that all students have a good experience, Unify America sets certain expectations in communications before and during the event.',
            intro: 'Here are a few examples of where students will encounter messages and instructions that help us ensure a respectful atmosphere for all participants:',
            sections: {
              signupPage: {
                title: 'Student Signup page',
                content:
                  'This is the page you share with your students so that they can register for their Civic Gym events. In our FAQs section, we let students know that bad behavior is exceptionally rare in our programs, but if something goes off the rails, they don’t have to handle anything alone. We let them know it’s okay to exit out of a bad conversation, and we let them know how to access our live support team. We also provide an email address if they want to contact us after the event to let us know about any problems they experienced.',
              },
              conversationTips: {
                title: '“Tips for Great Conversations”',
                content:
                  'This page is available to you and your students in the Civic Gym Hub. On the Tips page, we remind students they are participating in discussions, not debates. We prepare them for some respectful disagreement. And we provide the same pathways to help as noted above on the student signup page, should they be matched with a student who behaves inappropriately.',
              },
              emailReminders: {
                title: 'Emails leading up to the events',
                content:
                  'Like the rest of us, students need reminders. So we send several in the days and hours before their scheduled Civic Gym events. In addition to sharing their personal link to join their event, we take the opportunity to remind students to expect disagreement, be respectful, and reach out to us for help in the unlikely event their partner misbehaves.',
              },
              waitingRoom: {
                title: 'Live Event Waiting Room',
                content:
                  'When students join their event but before we match them with their partner, they may spend a few moments in a waiting room as hundreds or thousands of other students trickle in. The waiting room features a video presentation that helps set the tone. It reminds students to expect some respectful disagreement, stay curious, and critique ideas…but not the person.',
              },
              welcomeVideo: {
                title: 'Welcome video',
                content: 'Immediately before students are paired up with their partners, Harry Gottlieb, Founder of Unify America, welcomes everyone in a video that sets a friendly and hopeful tone for the event.',
              },
              liveEvent: {
                title: 'The live event',
                content:
                  'In both the Unify Challenge and Deep Dive, students kick off their conversation by introducing themselves, answering a couple of ice breaker questions, and reading aloud some norm-setting instructions. These instructions reiterate that it’s okay to disagree, but to speak and listen respectfully to one another.',
              },
            },
            additionalInfo: {
              title: 'Other ways we’re watching out for students',
              privacy: {
                title: 'Privacy Protection',
                content: 'Students are asked to introduce themselves using first names, and do not have any access to last names or contact information (unless they decide to share it themselves in their conversation).',
              },
              liveHelp: {
                title: 'Live Support',
                content: 'During live events, students have access to a live help button. Unify America team members are always just a click away to help with tech or any other issues as they arise.',
              },
              recording: {
                title: 'Optional Recording',
                content:
                  'Sessions are only recorded if both participating students give their consent. Recording is not required to participate in Civic Gym programs, and is always optional. If a student agrees to record their event but then changes their mind, they can email us and we will remove the recording from our database.',
              },
            },
          },
          moreReading: {
            hubTileLabel: 'Additional Study and Reading',
            title: 'Additional Study and Reading',
            headline: 'Additional Study and Reading',
            subheadline: 'Here are some ways to apply lessons or provide further study after students have completed their Civic Gym experience.',
            sections: {
              partisanship: {
                title: 'Partisanship',
                content1: 'Have students read a short brief from Pew Research about Americans’ concerns over the stress of talking about politics ',
                content2: '. In class or as a homework assignment, have students consider the following questions:',
                questions: {
                  question1: 'What do you think makes talking about politics stressful for many people?',
                  question2: 'How did the Unify America experience create conversations that were less stressful?',
                  question3: 'What aspects of the Unify America experience could you bring into everyday political conversations?',
                },
              },
              ideology: {
                title: 'Ideology and groups',
                content: 'Jonathan Haidt has a number of resources available on partisanship in contemporary politics, e.g. The Righteous Mind: Why Good People are Divided by Politics and Religion, particularly Chapter 9: Why are we so groupish?',
              },
            },
            otherBooks: {
              title: 'Other Books',
            },
            researchArticles: {
              title: 'Research & Articles',
            },
          },
          usingTheHub: {
            hubTileLabel: 'Using the Civic Gym Hub',
            title: 'Using the Civic Gym Hub',
            heroImageAlt: 'Illustration of an eraser head character wearing glasses.',
            subHeadline: 'A quick video walkthrough of everything you need to know to navigate the Hub, including student signup, playbook resources, and attendance tracking.',
            tutorialIntro: 'Here’s a 2-minute tutorial of everything you need to know about using the Hub:',
            hubVideoTitle: 'Using the Civic Gym Hub — tutorial video',
            hubVideoHeader: 'Civic Gym Hub Overview',
            insightsIntro: 'We recently launched our Insights tab, where you can find robust data about your class, your institution, and national participation in this semester’s Civic Gym program. Check out this tutorial to learn more:',
            insightsVideoTitle: 'Using the Insights tab — tutorial video',
            insightsVideoHeader: 'Using the Insights tab',
            attendanceIntro: 'Check out this video tutorial of our Attendance tab, where you can track your students’ participation in the Civic Gym program:',
            attendanceVideoTitle: 'Using the Attendance tab — tutorial video',
            attendanceVideoHeader: 'Using the Attendance tab',
          },
          howStudentsAreMatched: {
            hubTileLabel: 'How Students Are Matched',
            title: 'How Students Are Matched',
            heroImageAlt: 'Illustration of two students being matched for a conversation',
            intro: {
              para1: 'The Unify Challenge and Deep Dive connect students from all walks of life for meaningful conversations about big issues facing the country. To spark thoughtful dialogue, our delightfully nerdy matching algorithm pairs students based on their responses to key demographic and values-based questions during signup.',
              para2: 'The algorithm calculates a “difference score” for each potential pairing based on 8 or 9 criteria, and prioritizes matches where pairs attend different schools, grew up in different geographical locations, and possess the greatest variety in viewpoint and background. This maximizes contrast—and conversation potential—while ensuring a respectful and productive experience. It’s kind of like matchmaking, if Cupid were a data scientist with a passion for democracy.',
            },
            howItWorks: {
              title: 'How does the Match Work',
              para1: 'Once an educator registers for the Civic Gym, they are responsible for sending their students the signup form. That form asks students about their geographic location, political ideology, and opinions on a couple topics of national interest. The students can also select an event date and time that works with their schedule.',
              para2: 'At the start of each Unify Challenge and Deep Dive, our algorithm reviews the pool of students who have joined the event and matches them using the data from their signup form. The algorithm calculates a “difference score” for each potential pairing. A higher score denotes a match where the pair are from different schools and their signup form responses are the most different from one another’s. This maximizes contrast and conversation potential.',
            },
            faq: {
              title: 'FAQ',
              intro: 'Below are some answers to commonly asked questions from students (that you may be wondering about as well). Feel free to pass these along to your students as need be.',
              agreement: {
                question: '“Why did my partner and I agree on everything?”',
                answer1: 'That means it’s working! When we designed the Unify Challenge, one of our highest goals was to show Americans that despite our differences–in where we’re from, how we were raised, how we vote, even how we feel about certain hot-button issues–when it comes to big goals for our country, the vast majority of us agree.',
                answer2: 'Sometimes people mistake agreement for sameness, but that’s usually not the case. Not every difference manifests into a fight, and not every difference boils down to political ideology. Our average Difference Score is between a 7 to an 8 (out of 10). This means that you and your partner were likely different in terms of your backgrounds, where you’re from geographically, and your political beliefs. And despite those differences, you may still have found a lot of common ground.',
                answer3: 'Even when participants’ views are closely aligned, they almost always find their conversations meaningful and feel they have learned more about other points of view as well as their own.',
              },
              highSchoolOrInternational: {
                question: '“Why was I paired with someone in high school/an international student?”',
                answer: 'Many of our participants are dual-enrolled high school students or international students. And this is how the experience is meant to work. Your partner likely had a different viewpoint and experience than you do. While we recognize that these topics can sometimes feel sensitive or uncomfortable, we trust our participating institutions and students to decide what’s appropriate for their level of engagement.',
              },
              sameSchool: {
                question: '“Why was I paired with someone at my university?”',
                answer: 'Our goal is to match students with someone from another school, and our algorithm prioritizes that variable when creating pairs for the Unify Challenge and Deep Dive. That said, we are limited to the pool of students who show up for any given event. If we paired you with another student at your institution, it was probably because there were no students from other schools available.',
              },
              criteria: {
                question: '“What are the criteria you use to match partners?”',
                intro: 'Our algorithm relies on 8 data points (9 for the Deep Dive) that we gather from students when they sign up for their Civic Gym event:',
                list: {
                  school: 'What school they go to',
                  upbringing: 'Where they grew up (urban, suburban, rural)',
                  politicalSpectrum: 'Where they identify themselves on a political spectrum',
                  party: 'Which party/parties they vote for (or would vote for)',
                  gender: 'Gender (optional question)',
                  raceEthnicity: 'Race/ethnicity (optional question)',
                  policyQuestions: 'Two questions about specific policies or current events, which we occasionally change',
                  deepDiveTopic: 'One question about their chosen Deep Dive topic (if they’re signing up for the Deep Dive)',
                },
                weighting: 'Each variable is weighted differently. For example, we think it’s more important to match students with someone from a different school than it is to match them with someone of a different gender, and so “What school they go to” is weighted more heavily in our algorithm.',
                closing: 'The current weighting is producing more high-quality matches than ever (quick pat on the back), thanks to almost 5 years of constant tweaks and updates. We continue to watch matches closely and will continue dialing-in the algorithm whenever we feel we can improve it.',
              },
            },
          },
        },
        toShareWithStudents: {
          title: 'To Share with Students',
        },
      },
    },
    account: {
      title: 'Your Account',
      personalInfo: 'Personal Information',
      eventHistory: {
        title: 'Event History',
        noEvents: 'No history yet--check back after you’ve attended an event!',
        event: 'Event',
        completed: 'Completed',
      },
      accountUpdated: 'Account updated!',
      emailChangeConfirmNeeded: 'Please check your email to confirm your new email address. The link will expire in 30 minutes.',
    },
    confirmEmail: {
      processing: 'Processing email confirmation...',
      success: 'New email address confirmed!',
      magicLinkInvalid: 'Invalid or expired link. Please ensure you’re logged in and request a new one.',
      error: 'There was a problem confirming your new email address. Arrive on this page by mistake? Please log in and try again.',
    },
    signup: {
      title: 'Sign up for an Event',
      subtitle: 'Showing events for your organization:',
      noEvents: 'Unfortunately there are no available Unify Challenges at this time.',
      noEventsDescription: 'We update the schedule frequently, so please check back soon to reschedule!',
      signupSuccess: 'You have successfully signed up for the event. Please check your email for more details.',
      // preassessmentTitle: 'Before we schedule this deep dive event...',
      joiningYourPeers: 'Join your peers at', // interpolate user's orgName after this
      openChallenge: 'Includes participants outside of', // interpolate user's orgName after this
      signupDialog: {
        title: 'Please answer the below question(s) to sign up for the event.',
        chooseYourContact: 'Please select the faculty member you’re affiliated with',
        selectOne: 'Please select one',
      },
    },
    dashboard: {
      title: 'Your Upcoming Events',
      cancelSuccess: 'Your event has been successfully cancelled.',
      rescheduleSuccess: 'Previous event successfully cancelled; please select a new time below.',
      noEvents: 'Looks like you aren’t signed up for any events. Sign up below!',
      cancelRescheduleDialog: {
        confirm: 'Would you like to reschedule this event?',
        cancelEvent: 'Actually, I need to cancel my registration.',
      },
    },
    challenge: {
      joinedDialog: {
        hasPartnerJoined: 'Has your partner joined?',
        stillWaiting: 'Still waiting...',
        yup: 'Yup!',
      },
      leaveDialog: {
        areYouSure: 'Are you sure you’re ready to leave?',
        ifYouLeave: 'If you leave now, you will not be able to rejoin.',
        stay: 'I’d like to stay a little longer.',
        leave: 'I’m ready to leave.',
        studentCreditWarning: 'If you’re a student participating for class credit, make sure you click “Submit” on the last screen before you Leave!',
      },
      waitingRoom: {
        welcome: 'Welcome to the Unify Challenge',
        welcomeDeepDive: 'Welcome to the Deep Dive',
        checkInInstructions: 'Please click the button below to check in.',
        // Announced into the app live region, not rendered on screen — WCAG 4.1.3. Written to be
        // useful when heard once, out of context, with no visual cue alongside it.
        announceMatched: 'You have been matched with a partner. Connecting you to the conversation now.',
        announceRematched: 'You have been matched with a different partner. Please wait while we connect you.',
        // matched: 'You have been matched!',
        beginningShortly: 'Get ready! Your Unify Challenge is beginning shortly.',
        beginningShortlyDeepDive: 'Get ready! Your Deep Dive is beginning shortly.',
        // missingPartner: 'If your partner doesn’t appear in the video conference within 5 minutes, please click “Live Help” then choose the Live Support option. Start a live chat and and let us know your partner did not show, so we can rematch you.',
        early: 'You’ve arrived early! You’re welcome to hang out here as long as you’d like, but your Unify Challenge will not start until the scheduled time.',
        earlyDeepDive: 'You’ve arrived early! You’re welcome to hang out here as long as you’d like, but your Deep Dive will not start until the scheduled time.',
      },
      pleaseWaitDialog: {
        connectionTroubles: 'It seems your partner may be having connection troubles.',
        pleaseWait: 'We will try to find you a new partner!',
        contactSupport: 'If you don’t get connected with a new partner in the next few minutes, please contact support using the chat button below.',
      },
      lateView: {
        header: 'Sit tight!',
        para1: 'Today’s Unify Challenge has officially started already, but we may still be able to get you matched with a partner.',
        para1DeepDive: 'Today’s Deep Dive has officially started already, but we may still be able to get you matched with a partner.',
        para2: 'Please stay on this page. You’ll hang out here for the next few minutes (probably between 2 to 10 minutes) while we try to match you.',
        para3: 'If we’ve found you a partner, you’ll be automatically connected here!',
      },
      outage: {
        header: 'We have good news and bad news.',
        para1: 'The bad news: we have to cancel today’s Unify Challenge because of a service outage that’s beyond our control.',
        para2a: 'The good news: we’ve rescheduled you for ',
        para2b: ', and have already sent you an email with all the details.',
        para3: 'If you’d rather choose a different time, no problem. Just click below to visit your dashboard and choose a new time that works for you.',
        para4: 'Thanks for understanding. We’re truly sorry for the inconvenience.',
        dashboardButton: 'Visit Dashboard',
      },
      challengeNotFound: {
        header: 'Oops! We Can’t Find your reservation.',
        description: 'If you’re trying to reschedule or cancel your event, it’s possible that you may have already cancelled your reservation for that date.',
      },
    },
  },
  nav: {
    home: 'Home',
    challenges: 'Challenges',
    signup: 'Event Sign-up',
    participantPlaybook: 'Participant Playbook',
    page: 'Page',
    deepDiveInfo: 'Deep Dive Information',
    attendance: 'Attendance',
    insights: 'Insights',
    accountMenu: 'Account menu',
    menu: 'Menu',
    dsr: 'Durable Skills Report',
  },
  siteMap: {
    title: 'Site map',
    intro: 'Every page in Civic Gym, in one place.',
    navLabel: 'All pages',
    groups: {
      civicGym: 'Civic Gym',
      educatorHub: 'Educator hub',
      playbook: 'Educator playbook',
      studentResources: 'Student resources',
      help: 'Help',
      account: 'Your account',
    },
    links: {
      home: 'Home',
      attendance: 'Attendance',
      insights: 'Insights',
      facilitationGuide: 'Facilitation Guide',
      discussionIdeas: 'Discussion Ideas',
      studentSafety: 'Student Safety',
      moreReading: 'More Reading',
      programDesign: 'Civic Gym Program Design',
      aboutUnifyAmerica: 'About Unify America',
      conversationTips: 'Conversation Tips',
      accessibility: 'Accessibility',
      account: 'Account',
    },
  },
  educatorHub: {
    attendanceReport: {
      title: 'Attendance',
      showedUp: 'started, did not complete',
      didNotComplete: 'started, did not complete',
      completed: 'Completed',
      noShow: 'scheduled, did not join',
      registered: 'registered',
      scheduledToJoin: 'Scheduled to Join',
      totalRegistered: 'Total students scheduled to join',
      totalCompleted: 'Total students completed event',
      totalEducators: 'Total educators registered',
      selectEventMessage: 'Please select an event to view attendance data.',
      noDataMessage: 'When students sign up, their attendance data will go here. No data means no signups yet.',
      eventType: 'Event Type',
      season: 'Season',
      year: 'Year',
      allEventTypes: 'All Event Types',
      unifyChallenge: 'Unify Challenge',
      deepDive: 'Deep Dive',
      allSeasons: 'All Seasons',
      onlyMyStudents: 'Only my students',
      columns: {
        studentName: 'Student Name',
        studentEmail: 'Student Email',
        eventDateTime: 'Event Date/Time',
        challengeStatus: 'Status',
        challengeStatusHelp: '“Completed” = The student went through the entire discussion guide with their partner. \n\n“Scheduled to join” = The student is signed up. If the time and date are in the past, that means the student didn’t complete the event.',
        // Accessible name for the help button that reveals challengeStatusHelp. The tooltip text
        // itself is far too long to serve as a label, so the button gets a short one.
        challengeStatusHelpLabel: 'What do these statuses mean?',
        educatorName: 'Educator Name',
        studentsScheduled: '# students scheduled to join',
        studentsCompleted: '# students completed event',
      },
      export: 'Download',
      exportMenu: 'More download options',
      exportCSV: 'Export to CSV',
      exportExcel: 'Export to Excel',
      filterBy: 'Filter by',
      views: {
        educatorOverview: 'Educator overview',
        educatorDetail: 'Educator detail',
      },
    },
    insights: {
      title: 'Insights:',
      quicksightDialogTitle: 'QuickSight dashboard',
      sampleDataBadge: 'Sample Data',
      shareButton: 'Share data (under development)',
      yourClass: 'your class',
      yourCampus: 'your campus',
      national: 'national',
      quotes: {
        differentPerspective: 'I got to meet someone new with a totally different perspective on life than me and yet we still managed to find great compromises and great points of agreement between us.',
        listening: 'It reminded me how important listening and respect are in political discussions.',
        chill: 'I was really scared that I would be matched with someone who would yell at me or be mad, but it was actually very chill.',
        mainIssues: 'Getting to talk to another person about some of the main issues in America, in a discussion where no one would get into a heated argument.',
        madeAFriend: 'I feel like I made a friend. It helped me to express my opinion without being judged or taken out of context.',
        deeperConvos: 'It was really cool to talk to someone I never would have before. We agreed on a lot but also got into deeper conversations.',
        youngerPartnerPerspective: 'I liked hearing my partner’s perspective. He was from Colorado and younger than me, so it was interesting to hear his opinion and see how his experiences shaped his views.',
        beliefStatements: 'I enjoyed learning how to put my own thoughts and beliefs into words and statements and hearing about someone else’s perspective on the same issue.',
        befriendedStranger: 'The best part was actually speaking to a complete stranger about my views and having the courage to do so. It made me much more confident in my own views and I made a friend.',
        noJudgement: 'It was really cool just to talk about my beliefs and opinions without judgement. I never felt like anything I was saying was wrong or bad.',
        noArgument: 'The most valuable part was hearing someone else’s perspective and truly building a conversation, rather than an argument.',
        learnedToListen: 'Even when we did not agree on everything, I learned how to listen to different perspectives and express my own views respectfully.',
        realWorldConcerns: 'I am definitely now more eager to learn about how to communicate about real world concerns.',
        listenAndUnderstand: 'What was most valuable to me about this was trying to listen and understand their view and not just waiting for my turn to talk.',
        agreeToDisagree: 'Honestly my favorite part was when we disagreed because we were really able to hear each other out…we didn’t reach an ‘agreed’ state but understood where the other was coming from.',
      },
      imageAlts: {
        deepDiver1And2: 'Deep Sea Diver Characters',
        eraserGuitar: 'Eraser Head Character wearing a guitar',
        deepDiver1: 'Deep Sea Diver Character',
        eraserGlasses: 'Eraser Head Character wearing glasses',
        deepDiver2: 'Deep Sea Diver Character giving the okay sign',
        eraserWheelchair: 'Eraser Head Character in a wheelchair',
      },
      staffImpersonation: {
        selectOrgPlaceholder: 'Select organization...',
        selectOrgAriaLabel: 'Select organization',
        selectOrgContactPlaceholder: 'Select org contact...',
        selectOrgContactAriaLabel: 'Select org contact',
      },
      citations: {
        differentPerspectives: '— Miami Dade College student, Fall 2025 Unify Challenge feedback survey',
        listening: '— University of Florida student, Fall 2025 Unify Challenge feedback survey',
        umiami: '— University of Miami student, Fall 2025 Unify Challenge feedback survey',
        chill: '— Pikes Peak State College student, Fall 2025 Unify Challenge feedback survey',
        mainIssues: '— Delta College student, Spring 2026 Unify Challenge feedback survey',
        madeAFriend: '— Northeast Mississippi Community College student, Spring 2026 Unify Challenge feedback survey',
        deeperConvos: '— College of DuPage student, Spring 2026 Unify Challenge feedback survey',
        youngerPartnerPerspective: '— Oregon State University student, Spring 2026 Deep Dive feedback survey',
        beliefStatements: '— Case Western Reserve University student, Spring 2026 Deep Dive feedback survey',
        befriendedStranger: '— Miami Dade College student, Spring 2026 Deep Dive feedback survey',
        noJudgement: '— University of North Florida student, Spring 2026 Unify Challenge feedback survey',
        noArgument: '— Indiana University South Bend student, Spring 2026 Unify Challenge feedback survey',
        learnedToListen: '— Miami Dade College student, Spring 2026 Unify Challenge feedback survey',
        realWorldConcerns: '— Weber State University student, Summer 2026 Unify Challenge feedback survey',
        listenAndUnderstand: '— College of DuPage student, Summer 2026 Unify Challenge feedback survey',
        agreeToDisagree: '— Lipscomb University student, Summer 2026 Unify Challenge feedback survey',
      },
      sections: {
        participation: {
          title: 'Participation',
          studentsParticipated: 'students participated nationally',
          studentsParticipatedClass: 'students participated in your class',
          studentsParticipatedCampus: 'students participated on your campus',
          numbersByTopic: 'numbers by topic',
          totalOnCampus: 'total on campus',
          institutions: 'institutions',
          institutionsChartLabel: 'Participating institutions by type',
          institutionTypeHeader: 'Institution type',
          institutionsColumnLabel: 'Institutions',
          institutionTypes: {
            public4Year: 'Public 4-year',
            communityTechnical: 'Community/Technical',
            private4Year: 'Private 4-year',
            military: 'Military Institution',
            religious: 'Religious Institution',
            hbcu: 'Historically Black College or University',
            // Legend only. The full name stays in the chart's data table and its tooltip.
            hbcuShort: 'HBCU',
            other: 'Other',
          },
        },
        studentFeedback: {
          title: 'Student Feedback',
          completedPercent: 'of student participants completed the feedback survey',
          satisfactionScore: 'of all participating students were satisfied with the experience',
          averageClass: 'Average student rating from your class',
          satisfactionExplanation: '10 = “excellent”; 0 = “terrible”',
          satisfactionTableCaption: 'Average student satisfaction score, out of 10',
          groupHeader: 'Group',
          satisfactionScoreHeader: 'Satisfaction score (out of 10)',
          agreeColumnLabel: '% who agree',
          question1: 'The Unify Challenge made me feel more confident discussing complex issues with people who think differently from me.',
          question2: 'The Unify Challenge helped me understand perspectives different from my own.',
          question3: 'After this experience, I’m more likely to seek out conversations with people who think differently from me.',
          question4: 'I would recommend the Unify Challenge be used more broadly on campus.',
          deepDiveQ1: 'Something my partner shared or asked during the Deep Dive expanded my perspective on the topic we discussed.',
          deepDiveQ2: 'The facts presented during the Deep Dive caused me to expand my perspective.',
          deepDiveQ3: 'The Deep Dive made me more confident discussing complex issues with people who hold different views from mine.',
          deepDiveQ4: 'If I had the chance, I’d take the Deep Dive again.',
          agree: 'of students in your class agree',
        },
        workplaceReadiness: {
          title: 'Student Workplace Readiness',
          skillHeader: 'Skill',
          practicedColumnLabel: '% who practiced',
          responsesColumnLabel: '% of responses',
          questions: {
            skillsPracticed: 'Which skills did you practice today?',
            skillImproved: 'Which of these skills did you improve most?',
            skillFollowUp: 'Which of these skills would you most like to work on?',
          },
          choices: {
            askingFollowUpQuestions: 'Asking follow-up questions',
            identifyingValuesInTension: 'Identifying two values in tension',
            statingMyOwnValues: 'Stating values',
            findingCommonGround: 'Finding common ground',
            noneOfTheAbove: 'None of the above',
            // Deep Dive readiness questions ask about a different set of skills.
            // Keys must match the backend's choice keys exactly (see readiness.readinessAnswers).
            explainingMyReasoning: 'Explaining my reasoning',
            workingWithPartnerToBrainstorm: 'Brainstorming with a partner',
            recognizingCostsOrDownsides: 'Recognizing the downsides of solutions',
            notSure: 'Not sure',
          },
        },
        studentPairings: {
          titleWithPairings: 'Student Matchups & Demographics',
          title: 'Student Demographics',
          classAverageDescription: 'Average match score for students in your class',
          para1: 'Our algorithm considers eight different variables to prioritize matches across schools, backgrounds, and perspectives to encourage thoughtful, productive discussion.',
          para2: 'We give every student pairing a score. The higher the number, the wider the range of experiences and perspectives.',
          campusAverage: 'campus average',
          nationalAverage: 'national average',
          okMatch: 'ok match',
          goodMatch: 'good match',
          idealMatch: 'ideal match',
          percentageOfStudents: 'percentage of students (%)',
          matchQualityHeader: 'Match quality',
        },
        demographics: {
          solidLegendLabel: 'Solid = {group}',
          hatchedLegendLabel: 'Hatched = {group}',
          politicalSpectrum: {
            title: 'How students describe themselves',
            description: 'Inner ring = your campus; outer ring = national',
            categoryHeader: 'Political view',
            categories: {
              conservative: 'Conservative',
              somewhatConservative: 'Somewhat Conservative',
              libertarian: 'Libertarian',
              moderate: 'Moderate or Centrist',
              somewhatLiberal: 'Somewhat Liberal',
              liberal: 'Liberal',
              socialist: 'Socialist',
            },
          },
          votingRecord: {
            title: 'How students say they tend to vote',
            description: 'Inner ring = your campus; outer ring = national',
            categoryHeader: 'Voting pattern',
            categories: {
              alwaysRepublican: 'Always Republican',
              mostlyRepublican: 'Mostly Republican',
              alwaysDemocrat: 'Always Democrat',
              mostlyDemocrat: 'Mostly Democrat',
              acrossPartyLines: 'Across party lines',
              mostlyThirdParty: 'Mostly third-party',
              chooseNotToVote: 'I choose not to vote',
            },
          },
        },
        aFewMoreNiceWords: {
          title: 'A Few More Nice Words',
        },
        quicksight: {
          header: 'But wait...there’s more.',
          description: 'Written feedback from students • Student demographic data • Participating institutions • Registered faculty at my school • Student responses to discussion guide questions',
        },
      },
      interimMessage: {
        title: 'This page lives in the future.',
        imageAlt: 'Two eraser head characters with an American flag, both looking into the distance with binoculars',
        specifically: 'Specifically',
        para2: 'That’s when we’ll repopulate this space with fresh data to show how your students–and students nationwide–experienced their Civic Gym season.',
        para3: 'In the meantime, you’re welcome to explore data from our past seasons, including demographic insights, lists of participating institutions, and student responses to discussion-guide questions.',
        quicksightButton: 'Show me the historical data',
      },
      invalidMockData: {
        title: 'Invalid mock data value',
        description: 'The "mockData" URL parameter must be "uc" (Unify Challenge) or "dd" (Deep Dive). No data has been loaded.',
      },
    },
  },
  form: {
    fields: {
      firstName: 'First Name',
      lastName: 'Last Name',
      email: 'Email address',
      newsletter: 'I’d like to receive a monthly email from Unify America’s founder with stories about how everyday Americans can move our country forward.',
      newsletterStudent: 'Sign me up for the “Civic Binge,” Unify America’s occasional student newsletter featuring bold campus initiatives, real student stories, and ways to flex your civic muscles.',
      politicalSpectrum: 'How would you most likely describe yourself?',
      votingRecord: 'How do you tend to vote?',
      isStudent: 'Are you currently a college student?',
      citizenScholars: 'Were you referred by the Citizens and Scholars Faculty Institute?',
      howHeard: 'How did you hear about the Unify Challenge? (check all that apply)',
      zipCode: 'What is your zip code?',
      urbanRural: 'Which of these best describes where you primarily grew up?',
      urbanRuralStudent: 'Which of these best describes where you primarily grew up?',
      dob: 'In what month and year were you born?',
      birthMonth: 'Month',
      birthYear: 'Year',
      gender: 'What’s your gender?',
      genderDescription: 'Please describe yourself.',
      race: 'What’s your race and/or ethnicity? (choose all that apply)',
      sharedGoals: 'True or false: Across party lines, Americans share many of the same goals for the country.',
      sharePointOfView: 'How comfortable do you feel sharing your point of view on political or current events in class or on campus?',
      futureOfDemocracy: 'How hopeful are you about the future of our democracy?',
      impactOfConversation: 'When it comes to strengthening our democracy, how much of an impact do you think conversations between people with different political viewpoints can make?',
      professorOrOrganization: 'Please select the professor or organization who you are affiliated with.',
      gun_ownership: 'Which of the following statements best describe you?',
      free_speech: 'Agree or Disagree: Free speech should be restricted on college campuses if it causes students to feel threatened or unsafe.',
      social_media: 'Which do you think is the better way to protect children’s and teens’ mental health on social media?',
      voting_and_elections: 'When it comes to voting in America, which of the following comes closest to your point of view?',
      choiceForAmerica: 'If you had to choose, which would you prefer for America?',
      healthcareInAmerica: 'If you had to choose how healthcare was provided in America, which would you prefer?',
      futureOfAmerica: 'When you think about the future of America, which is more important to you?',
      faceToFaceConversation: 'How often do you have the chance to have face-to-face conversations with people who hold different political perspectives or beliefs from yours?',
      feelingsOnFaceToFaceConversation: 'How do you feel about having face-to-face conversations with people who have different viewpoints about the country’s future?',
      differentPerspectiveMisinformation: 'When you encounter someone with a different perspective, how often do you assume their beliefs are based on misinformation or a lack of understanding?',
      trustOpposingViewsGoodReason: 'How much do you trust that people with views opposite of yours have good reasons behind their beliefs?',
      trustDifferentViewsCareToMakeCountryBetter: 'How much do you trust that people with different political views than yours care about making our country a better place?',
      iAgreeToTerms: 'I agree to Unify America’s ',
      termsOfServiceLink: 'Terms of Service',
      and: ' and ',
      privacyPolicyLink: 'Privacy Policy',
      isConsent: 'I agree to the terms of ',
      isConsentLink: 'Unify America’s Consent and Release',
      isRecord: 'I consent to Unify America recording audio and video of this session, and I agree to the ',
      recordingReleaseLink: 'Recording Release',
      terms: ' terms.',
      isRecordLink: 'and agree to the consent',
      intendedCollegeMajor: 'Intended major',
      confidenceDiscussingComplexIssues: 'How confident are you in your ability to discuss complex issues with people who might think differently from you?',
      conversationsWorthwhile: 'How often are conversations between people who see the world differently actually worthwhile?',
      isChallengeRequiredAssignment: 'Is the {eventName} a required assignment for you?',
    },
    helpText: {
      votingRecord: '(If you haven’t voted or are unable to vote, how might you vote?)',
      multiSelectPanel: 'Select all that apply, then click/tap Done.',
      dateFormat: 'Format: MM/YYYY',
    },
    placeholders: {
      selectAllThatApply: 'Please select all that apply',
      selectOne: 'Please select one',
      genderDescription: 'Please describe your gender',
      dateFormat: 'Enter as mm/yyyy',
      intendedCollegeMajorDescription: 'Please specify your intended major',
    },
    errors: {
      firstName: 'First Name is required',
      lastName: 'Last Name is required',
      email: 'Please enter a valid email',
      required: 'Oops! Please make a selection.',
    },
    choices: {
      gender: {
        male: 'Male',
        female: 'Female',
        nonBinary: 'Nonbinary',
        preferNotToSay: 'I’d rather not say',
        describeYourself: 'I describe myself differently',
      },
      politicalSpectrum: {
        conservative: 'Conservative',
        somewhatConservative: 'Somewhat Conservative',
        libertarian: 'Libertarian',
        moderateOrCentrist: 'Moderate or Centrist',
        somewhatLiberal: 'Somewhat Liberal',
        liberal: 'Liberal',
        socialist: 'Socialist',
      },
      votingRecord: {
        alwaysRepublican: 'I always vote for Republicans',
        alwaysDemocratic: 'I always vote for Democrats',
        mostlyRepublican: 'I mostly vote for Republicans',
        mostlyDemocratic: 'I mostly vote for Democrats',
        independent: 'I vote across party lines (both Republicans and Democrats)',
        mostlyThirdParty: 'I mostly vote for third-party candidates',
        chooseNotToVote: 'I choose not to vote',
      },
      urbanRural: {
        metropolitanArea: 'City or urban area',
        suburb: 'Suburb',
        ruralArea: 'Rural area',
      },
      maritalStatus: {
        single: 'Single',
        marriedOrPartnered: 'Married/Partnered',
        separatedOrDivorced: 'Separated/Divorced',
        widowed: 'Widowed',
      },
      education: {
        noSchooling: 'No schooling completed',
        elementarySchool: 'Elementary school',
        someHighSchool: 'Some high school',
        highSchoolGED: 'High school graduate or GED',
        currentlyInCollege: 'Currently in college',
        tradeOrVocationalTraining: 'Trade or vocational training',
        associatesDegree: 'Associate’s degree',
        bachelorsDegree: 'Bachelor’s degree',
        mastersDegree: 'Master’s degree',
        professionalDegree: 'Professional degree',
        doctoralDegree: 'Doctoral degree',
      },
      religion: {
        evangelicalChristian: 'Evangelical Christian',
        historicallyBlackChristian: 'Historically Black Christian',
        protestant: 'Protestant (Lutheran, Methodist, Pentecostal, Baptist, etc.)',
        christianOrthodox: 'Christian Orthodox',
        catholic: 'Catholic',
        mormon: 'Mormon',
        jehovahsWitness: 'Jehovah’s Witness',
        anotherTypeOfChristian: 'Another type of Christian',
        jewish: 'Jewish',
        muslim: 'Muslim',
        hindu: 'Hindu',
        buddhist: 'Buddhist',
        newAgeOrIndividualSpirituality: 'New Age or individual spirituality',
        other: 'A different religion than those listed above',
        agnostic: 'Agnostic',
        atheist: 'Atheist',
        nonReligiousSpiritual: 'I practice with a non-religious spiritual community',
      },
      race: {
        asian: 'Asian',
        blackOrAfricanAmerican: 'Black or African American',
        hispanicOrLatino: 'Hispanic or Latino',
        middleEasternOrNorthAfrican: 'Middle Eastern or North African',
        nativeAmericanOrAlaskaNative: 'American Indian or Alaska Native',
        nativeHawaiianOrPacificIslander: 'Native Hawaiian or Pacific Islander',
        white: 'White',
        ratherNotSay: 'I’d rather not say',
      },
      futureOfDemocracy: {
        veryHopeful: 'Very hopeful',
        somewhatHopeful: 'Somewhat hopeful',
        neither: 'Neither hopeful nor unhopeful',
        somewhatUnhopeful: 'Somewhat unhopeful',
        veryUnhopeful: 'Very unhopeful',
      },
      sharePointOfView: {
        veryComfortable: 'Very comfortable',
        somewhatComfortable: 'Somewhat comfortable',
        neither: 'Neither comfortable nor uncomfortable',
        somewhatUncomfortable: 'Somewhat uncomfortable',
        veryUncomfortable: 'Very uncomfortable',
      },
      sharedGoals: {
        true: 'True. We are mostly united when it comes to goals.',
        false: 'False. We are mostly divided when it comes to goals.',
      },
      impactOfConversation: {
        bigImpact: 'A big impact',
        littleImpact: 'A little bit of an impact',
        noImpact: 'No impact',
        makeThingsWorse: 'It’s likely to make things worse',
        none: 'None',
        slight: 'Slight',
        moderate: 'Moderate',
        strong: 'Strong',
        veryStrong: 'Very strong',
      },
      howHeard: {
        colleagueFriendFamily: 'From a colleague, friend, or family member',
        collegeOrProfessor: 'From my college or professor',
        socialMedia: 'From social media',
        webSearch: 'From a web search',
        other: 'Other',
      },
      gunOwnership: {
        noRestrictions: 'I do not think there should be any restrictions in our country on owning firearms.',
        ownGun: 'I currently own a firearm.',
        dontOwnGunButWill: 'I do not own a firearm, but probably will someday.',
        notSure: 'I am not sure if I will ever own a firearm.',
        neverWillOwn: 'I will never own a firearm.',
        shouldBeIllegal: 'I do not think people in our country should be allowed to own firearms.',
      },
      freeSpeech: {
        stronglyAgree: 'Strongly agree',
        somewhatAgree: 'Somewhat agree',
        neitherAgreeNorDisagree: 'Neither agree nor disagree',
        somewhatDisagree: 'Somewhat disagree',
        stronglyDisagree: 'Strongly disagree',
      },
      votingAndElections: {
        rightAndDuty: 'Voting is a right and a duty.',
        rightNotDuty: 'Voting is a right but not a duty.',
        neitherRightNorDuty: 'Voting is neither a right nor a duty.',
      },
      socialMedia: {
        timeLimits: 'Require social media companies to enforce daily time limits for users under 18',
        digitalWellnessEducation: 'Require schools and parents to deliver digital-wellness education and training',
      },
      isStudent: {
        true: 'Yes',
        false: 'No',
      },
      externalId: {
        true: 'Yes',
        false: 'No',
      },
      choiceForAmerica: {
        lowerTaxes: 'Lower taxes and a government that provides fewer services',
        higherTaxes: 'Higher taxes and a government that provides more services',
      },
      healthcareInAmerica: {
        governmentRun: 'A government-run health system',
        privateInsurance: 'A private-insurance-based health system',
      },
      futureOfAmerica: {
        improving: 'Improving the way things are today',
        preserving: 'Preserving our values and traditions',
      },
      faceToFaceConversation: {
        never: 'Never',
        rarely: 'Rarely',
        sometimes: 'Sometimes',
        often: 'Often',
        always: 'Always',
      },
      feelingsOnFaceToFaceConversation: {
        veryUncomfortable: 'Very uncomfortable',
        somewhatUncomfortable: 'Somewhat uncomfortable',
        neither: 'Neither comfortable nor uncomfortable',
        somewhatComfortable: 'Somewhat comfortable',
        veryComfortable: 'Very comfortable',
      },
      differentPerspectiveMisinformation: {
        veryOften: 'Very often',
        somewhatOften: 'Somewhat often',
        occasionally: 'Occasionally',
        rarely: 'Rarely',
        never: 'Never',
      },
      trust: {
        completelyTrust: 'Completely trust',
        mostlyTrust: 'Mostly trust',
        neutral: 'Neutral',
        mostlyDoNotTrust: 'Mostly do not trust',
        doNotTrustAtAll: 'Do not trust at all',
      },
      intendedCollegeMajor: {
        undecided: 'Undecided / Exploring',
        artsAndHumanities: 'Arts & Humanities',
        business: 'Business / Economics',
        communications: 'Communications / Media',
        computerScience: 'Computer Science / IT',
        education: 'Education',
        engineering: 'Engineering',
        health: 'Health / Nursing',
        math: 'Math / Statistics',
        naturalSciences: 'Natural Sciences (Biology, Chemistry, Agriculture, etc.)',
        socialSciences: 'Social Sciences (Political Science, Psychology, etc.)',
        other: 'Other',
      },
      confidenceDiscussingComplexIssues: {
        veryConfident: 'Very confident',
        somewhatConfident: 'Somewhat confident',
        notVeryConfident: 'Not very confident',
        notConfidentAtAll: 'Not confident at all',
      },
      conversationsWorthwhile: {
        almostAlways: 'Almost always worthwhile',
        usually: 'Usually worthwhile',
        sometimes: 'Sometimes worthwhile',
        rarely: 'Rarely or never worthwhile',
      },
      isChallengeRequiredAssignment: {
        yes: 'Yes, it’s required.',
        no: 'No, it’s optional.',
      }
    },
  },
  dsr: {
    reportTitle: 'Durable Skills Report',
    greeting: 'Nice work, {participantFirstName}.',
    welcome1: 'You just had a real conversation about topics that don’t have easy answers, and you had it with someone who sees the world differently than you do. Many people never take the chance to do that. So, seriously: nice work.',
    welcome2: 'During your conversation, you used some real skills, maybe without noticing. This report grabs a few of those moments and hands them back to you. You\'ll see what you said, what it shows you\'re already good at, and how you might sharpen each skill next time around.',
    welcome3: 'These are the kinds of skills that will be vital in your future workplace. But they\'re also what makes a class discussion click, what helps you work through a hard moment with a friend or your family, and what will make you the person a community actually wants in the room.',
    topic: 'Topic',
    whatYouSaid: 'What you said',
    whatYouDidWell: 'What you did',
    whyItMatters: 'Why it matters',
    InYourCommunity: 'In your community',
    atWork: 'At work',
    tryThis: 'Try this next time',
    footerMadeLabel: 'How we made this report.',
    footerMadeText: 'Unify America used an AI tool to read the transcript of your conversation and find the moments where your own words showed a "durable skill." It didn\'t grade you or score you, and it doesn\'t learn from your conversation. This is a pilot — a new feature we\'re still testing and improving. So if a moment in here doesn\'t match how you remember it, tell us with the feedback form above or email us at ',
    footerPrivacyLabel: 'Your privacy matters to us.',
    footerPrivacyText: 'We treat your conversation as yours. Before the AI read the transcript, we removed your name. Your report comes to you and no one else, and we don\'t store it to train the AI or share it with anyone.',
    footerFrameworkLabel: 'Why these skills matter — now and later.',
    footerFrameworkText: 'The skills in this report have names that employers and colleges already use. NACE (the National Association of Colleges and Employers) lists them as what employers look for in new hires. AAC&U (the Association of American Colleges and Universities) builds them into the rubrics colleges use to measure things like critical thinking and civic engagement. But here\'s the part that\'s really about you: these are skills, not fixed talents. They grow every time you use them. The conversation you just had was a rep. The more reps you get, the more these show up where they count — in a job, on a team, and anywhere people are trying to work through something hard together.',
    selectDsrPlaceholder: 'Select report...',
    selectDsrAriaLabel: 'Select report',
    inProgressStateTitle: 'We\'re working on it!',
    inProgressStateDescription: 'Your Durable Skills Report isn\'t quite ready yet. Please check back in a day or two.',
    failedStateTitle: 'Something didn\'t work.',
    failedStateDescription: 'Unfortunately, we weren\'t able to create your Durable Skills Report. Maybe your conversation was very short, or there were audio issues, or our system just couldn\'t find moments from your conversation to say something helpful about. If you\'d like to try again, you can sign up for another conversation by clicking Event Sign-up above.',
  },
};
